// extracted by mini-css-extract-plugin
export default {"appPage":"gf","fullWidth":"hf","header":"if","notFullWidth":"jf","scrolled":"kf","main":"lf","contentContainer":"mf","notchSpacer":"nf","sponsors":"of"};